import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { displayFaresInCalendar, getSegments } from '../../../redux/currentSearch/selectors';
import { CalendarTypeProp, SearchSegment } from '../../../models';
import { ConnectedFaresRenderInner } from './FaresRenderInner';

export const FaresProviderRenderDesktop = ({ date, calendarType, isDayDisabled, displayFaresInCalendar, segments }) => {
    return (
        <React.Fragment>
            {displayFaresInCalendar && (
                <ConnectedFaresRenderInner
                    entered
                    isDayDisabled={isDayDisabled}
                    date={date}
                    calendarType={calendarType}
                    segmentId={segments[0].id}
                />
            )}
        </React.Fragment>
    );
};

FaresProviderRenderDesktop.propTypes = {
    date: PropTypes.instanceOf(Date).isRequired,
    calendarType: CalendarTypeProp.isRequired,
    displayFaresInCalendar: PropTypes.bool.isRequired,
    isDayDisabled: PropTypes.bool.isRequired,
    segments: PropTypes.arrayOf(SearchSegment).isRequired,
};

const mapStateToPropsSelectorRender = createStructuredSelector({
    displayFaresInCalendar,
    segments: getSegments,
});

export const ConnectedFaresProviderRenderDesktop = connect(mapStateToPropsSelectorRender)(FaresProviderRenderDesktop);
